module.exports = __webpack_public_path__ + "img/gc_country_flag_br.eca92846.svg";